import sk1 from "../assets/cmspictures/sk1.jpg";
import sk2 from "../assets/cmspictures/sk2.jpg";
import sk3 from "../assets/cmspictures/sk3.jpg";
import sk4 from "../assets/cmspictures/sk4.jpg";
import sk5 from "../assets/cmspictures/sk5.jpg";
import sk6 from "../assets/cmspictures/sk6.jpg";
import sk7 from "../assets/cmspictures/sk7.jpg";
import sk8 from "../assets/cmspictures/sk8.jpg";
import sk9 from "../assets/cmspictures/sk9.jpg";
import sk10 from "../assets/cmspictures/sk10.jpg";
import sk11 from "../assets/cmspictures/sk11.jpg";
import sk12 from "../assets/cmspictures/sk12.jpg";
import sk13 from "../assets/cmspictures/sk13.jpg";
import sk15 from "../assets/cmspictures/sk15.jpg";
import sk16 from "../assets/cmspictures/sk16.jpg";
import sk17 from "../assets/cmspictures/sk17.jpg";
import sk18 from "../assets/cmspictures/sk18.jpg";
import sk19 from "../assets/cmspictures/sk19.jpg";
import sk20 from "../assets/cmspictures/sk20.png";
import sk21 from "../assets/cmspictures/sk21.jpg";
import sk22 from "../assets/cmspictures/sk22.jpg";
import sk23 from "../assets/cmspictures/sk23.jpg";
import sk24 from "../assets/cmspictures/sk24.jpg";
import sk25 from "../assets/cmspictures/sk25.jpg";
import sk26 from "../assets/cmspictures/sk26.jpg";
import instagram from "../assets/insta.png";
import img5 from "../assets/flyers/firstskate.jpeg";
import img2 from "../assets/flyers/BrownsvilleClinic.jpg";
import img3 from "../assets/flyers/openhearth.png";
import img4 from "../assets/flyers/openhearth2.png";
import img1 from "../assets/flyers/xmas.jpeg";
import img6 from "../assets/flyers/SK8JAMEVENT.jpeg";
import img7 from "../assets/flyers/SK8JAMEVENT2.jpeg";
import img8 from "../assets/flyers/10000.jpeg";
import flower from "../assets/flower.png";
import flower2 from "../assets/flower2.png";
import downarrow from "../assets/downarrow.png";
import downarrow2 from "../assets/downarrow2.png";
import downarrow3 from "../assets/downarrow2.png";

export const images = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  sk1,
  sk2,
  sk3,
  sk4,
  sk5,
  sk6,
  sk7,
  sk8,
  sk9,
  sk10,
  sk11,
  sk12,
  sk13,
  sk15,
  sk16,
  sk17,
  sk18,
  sk19,
  sk20,
  sk21,
  sk22,
  sk23,
  sk25,
  sk26,
  instagram,
  flower,
  flower2,
  downarrow,
  downarrow2,
  downarrow3,
};

export const slideOne = [sk12, sk25];

export const slideTwo = [sk1, sk24];

export const slideThree = [sk13, sk22];

export const slideFour = [sk15, sk11, sk9];

export const slideFive = [sk3, sk4];

export const originSlide = [
  "My name is Alfonso, I grew up in the Rutland 90z Community of East Flatbush where I still reside. I've been skateboarding for about 14 years & teaching it for just as long which got me involved with the Harold Hunter Foundation as a mentor/coach for the youth. As a skateboarder who skated all 5 boroughs I started to realize how important it is to develop my community & build success in my hood. This drive came from the inaccessibility, lack of literacy, food deserts, and a need for safety. I'm the founder of Environmental Hood Restoration (EHR) . Our organization was made by the community and for the community with the purpose to help feed, repair, clean & give back to our neighborhood of East Flatbush, Brooklyn with a grander scope of New York & beyond. I started this grassroots organization in order to tackle several initiatives that I know are needed after assessing the neighborhood I grew up in.",
  "I knew that in order to build the community, I needed to get the people of the community involved. I set up community meetings that involved my neighborhood leaders and my building’s organization called the Rutland Plaza tenants association which I later became president of. In these meetings we brainstormed what was needed to solve the issues seen in the 90z community and as well it brought a board of trustees that became supportive to EHR along with my own family and friends",
  "With the backing of my community and the community's allies we started several initiatives. The initiatives include free skateboarding clinics for the youth, access to free produce/goods on a weekly basis, community based events, & furthering community engagement. We are currently working on other initiatives including a neighborhood fridge, a community garden and as well having the people reclaim their spaces and gain access to the Rutland building community space. Many of these initiatives have garnered attention and support from different sponsors including Supper Collectives, Saint John’s Bread & Life, and The Harold Hunter Foundation. Our growing role has created a platform for people to feel part of something bigger than them; through generosity and investing in each other we create a sense of belonging and a sense of community in each other, a footprint we can be proud of.",
];
